import React, {useEffect, useState} from "react";
import {Button, Col, Form, Row} from 'react-bootstrap';
import APIService from "../../services/ApiService";


import CardHome from "../cards/cardHome";
import {useLocation} from "react-router-dom";

const Home = () => {

    const [courseList, setCourseList] = useState([]);
    const [periodo, setPeriodo] = useState("");
    const [pageSize, setPageSize] = useState(25)
    const [livello, setLivello] = useState("");
    const [luogo, setLuogo] = useState("");
    const [levelOption, setLevelOption] = useState([]);
    const [piscineOption, setPiscineOption] = useState([])
    const location = useLocation();

    useEffect(() => {
        location.state?.selectedPool && setLuogo(location.state?.selectedPool);

        getCoursesBySize();
        getLevels();
        getLuogoPiscine();

        return () => setPageSize(25);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setCourseList([])
        getCoursesBySize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageSize, livello, periodo, luogo])

    const getCoursesBySize = () => {
        let pageParams = {
            pageSize: pageSize,
            hideOld: true,
            ...(periodo && {period: periodo}),
            ...(livello && {level: livello}),
            ...(luogo && {piscina: luogo})
        };

        let courseRow = [];
        APIService.getCourses(pageParams)
            .then((jOb) => {
                jOb.courseDtos.forEach((course, idx) => {
                    courseRow.push(
                        <Col xs={12} sm={6} key={idx}>
                            <CardHome id={course.id} title={course.title} piscinaId={course.piscinaId} price={course.price}
                                      noOfLessons={course.noOfLessons} levelCourseId={course.levelCourseId}
                                      start={course.start}/>
                        </Col>
                    )
                })
                setCourseList(courseRow);
            })
            .catch();
    }

    const handleResetFiltri = (e) => {
        e.preventDefault();

        setPeriodo("");
        setLivello("");
        setLuogo("");
        setPageSize(25);
    }

    const getLevels = () => {
        let items = [];
        items.push(<option key={Date.now()} value="">Livello</option>)
        APIService.getLevelList().then((levelObj) => {
            levelObj.levelCourseDtos.forEach((item, index, array) => {
                items.push(<option key={index} value={item.id}>Livello {item.level}</option>)

                if (index === 9 && index !== levelObj.levelCourseDtos.length - 1) {
                    items.push(<option key="divider" disabled>__________________</option>);
                }
            })

            setLevelOption(items);
        })
    }

    const getLuogoPiscine = () => {
        let items = [];
        items.push(<option key={Date.now()} value="">Luogo</option>)
        APIService.getLuogoPiscineList().then(poolList => {
            poolList.piscinaDtos.forEach((item, index) => {
                items.push(<option key={index} value={item.id}>{item.title}</option>)
            })

            setPiscineOption(items);
        })

    }

    return (
        <>
            <Row>
                <Col lg={6}>
                    <div className={'paragraph-section'}>
                        <h2 className={'title'}>Shop</h2>

                        <p>
                            Benvenuto nello shop di NSL!<br/>
                            Scopri i nostri corsi: usa i filtri per individuare quello più adatto a te:
                        </p>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} lg>
                    <Form.Select aria-label="Default select example" value={periodo || ""} className={'w-100 mb-3'}
                                 onChange={(e) => setPeriodo(e.target.value)}>
                        <option value="">Periodo</option>
                        <option value="Summer">Estivi</option>
                        <option value="Winter">Invernali</option>
                    </Form.Select>
                </Col>
                <Col xs={12} lg>
                    <Form.Select aria-label="Default select example" value={luogo || ""} onChange={(e) => setLuogo(e.target.value)} className={'w-100 mb-3'}>
                        {piscineOption}
                    </Form.Select>
                </Col>
                <Col xs={12} lg>
                    <Form.Select aria-label="Default select example" value={livello || ""} onChange={(e) => setLivello(e.target.value)} className={'w-100 mb-3'}>
                        {levelOption}
                    </Form.Select>
                </Col>
                <Col xs={12} lg={'auto'}>
                    <div className={'d-flex flex-column align-items-end align-items-lg-center'}>
                        <Button variant="primary" onClick={(e) => getCoursesBySize(e)} className={'fw-bold px-5 px-lg-4'}>
                            <svg viewBox="0 0 57.1 56.7" className={'icon-btn me-2'}>
                                <path d="M42.2,37.4c3-4,4.6-9,4.6-14C46.8,10.5,36.3,0,23.4,0C10.5,0,0,10.5,0,23.4c0,12.9,10.5,23.4,23.4,23.4
                         c5.2,0,10.3-1.8,14.4-5l14.9,14.9l4.4-4.4L42.2,37.4z M40.6,23.4c0,9.5-7.7,17.2-17.2,17.2c-9.5,0-17.2-7.7-17.2-17.2
                         c0-9.5,7.7-17.2,17.2-17.2C32.9,6.2,40.6,13.9,40.6,23.4z"/>
                            </svg>
                            Invio
                        </Button>
                        <Button variant={'link'} className={'mt-1'} onClick={(e) => handleResetFiltri(e)}>
                            reset filtri
                        </Button>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col lg={6}>
                    <div className={'paragraph-section'}>
                        <p>
                            Per completare l'iscrizione, selezionate il corso desiderato e procedete quindi al pagamento tramite carta di credito, Twint, PostFinance o nel caso non funzioni richiedere a corsi@nuotosportlocarno.ch polizza QR (bonifico da effettuare entro 2 giorni).
                        </p>
                        <p>
                            Tutte le informazioni sui livelli da scegliere e sul metodo formativo di Swiss Aquatics sono disponibili al seguente link:
                        </p>
                        <p>
                            👉 <a
                            href={'https://www.swiss-aquatics.ch/wp-content/uploads/2021/01/Brochure-Formazione-Kids.pdf'}
                            target={'_blank'}
                            rel="noreferrer">https://www.swiss-aquatics.ch/wp-content/uploads/2021/01/Brochure-Formazione-Kids</a>
                        </p>
                    </div>
                </Col>
            </Row>
            <Row>
                {courseList.length > 0 ? courseList : ""}
            </Row>
            <Row className={'mb-5'}>
                <Col>
                    <Button variant={'link'} onClick={(e) => setPageSize(size => size + 25)} className={'link-shape up-down p-0'}>
                        Carica di più
                    </Button>
                </Col>
            </Row>
        </>
    );
}

export default Home;